module.exports = __webpack_public_path__ + "Flag-116.3b2dcdf4a08b727d5e84a9d430d1fc92.svg";